import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import Option from './Option/Option';
import CSS from './MenuList.scss';
export var IMenuItemType;
(function (IMenuItemType) {
    IMenuItemType["standard"] = "standard";
    IMenuItemType["faded"] = "faded";
    IMenuItemType["disabled"] = "disabled";
    IMenuItemType["danger"] = "danger";
    IMenuItemType["header"] = "header";
})(IMenuItemType || (IMenuItemType = {}));
const MenuList = ({ style, className, show, checkbox, selectedOptions, optionData, selectedOption, endButtonText, testId = 'MenuList', onChange, overflow, onHoverOption, onMouseEnterOption, onMouseLeaveOption, onMouseEnterIcon, onMouseLeaveIcon, }) => {
    const menuEl = useRef(null);
    const [hoveredOption, setHoveredOption] = useState(null);
    const classes = [CSS.MenuList, className ? className : ''];
    useEffect(() => {
        onHoverOption?.(hoveredOption);
    }, [hoveredOption]);
    const options = optionData.map((opt, i) => {
        const isActive = !!selectedOption && selectedOption.val === opt.val || !!selectedOptions?.map?.(item => item.val)?.includes?.(opt.val);
        return (_jsx(Option, { id: opt.val, checkbox: checkbox, testId: opt.testId ? opt.testId : 'Option', icon: opt.icon ? opt.icon : undefined, rhsText: opt.rhsText ? opt.rhsText : undefined, fontFamily: opt.fontFamily, overflow: overflow, endButtonText: endButtonText, isHovered: opt.val === hoveredOption?.val, type: opt.type || IMenuItemType.standard, isActive: isActive, isIndented: opt.isIndented, isDivider: opt.isDivider, onClick: () => {
                onChange(opt);
                opt?.fn?.();
            }, iconOnClick: () => opt?.iconFn?.(opt), onMouseEnter: () => {
                onMouseEnterOption?.(opt);
                setHoveredOption((prevOption) => {
                    if (prevOption)
                        onMouseLeaveIcon?.(prevOption);
                    if (prevOption)
                        onMouseLeaveOption?.(prevOption);
                    return opt;
                });
            }, iconOnMouseEnter: () => onMouseEnterIcon?.(opt), iconOnMouseLeave: () => onMouseLeaveIcon?.(opt), children: opt.text }, i));
    });
    if (!show)
        return null;
    return (_jsx("div", { ref: menuEl, className: classes.join(' '), "data-testid": testId, style: style, onMouseLeave: () => {
            setHoveredOption((prevOption) => {
                if (prevOption)
                    onMouseLeaveIcon?.(prevOption);
                if (prevOption)
                    onMouseLeaveOption?.(prevOption);
                return null;
            });
        }, children: options }));
};
export default MenuList;
